import _ from 'lodash';
import { AfterViewInit, Component, DestroyRef, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { RouteReuseStrategyService } from '../../services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { DownloadExcelPaddleQrModalService } from 'app/router-wrapper/services/download-excel-paddle-qr-modal.service';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { BulkCheckoutComponent } from 'app/event/components/bulk-checkout/bulk-checkout.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-in-person-event-attendees-page',
  templateUrl: './in-person-event-attendees-page.component.html',
  styleUrls: ['./in-person-event-attendees-page.component.scss']
})
export class InPersonEventAttendeesPageComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild("container", { static: true }) containerRef: ElementRef;
  
  destroyRef = inject(DestroyRef)

  public eventId = null;

  public takeUntilSubject: Subject<any> = new Subject();
  private takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();

  constructor(
    private route: ActivatedRoute,
    private routeReuseStrategyService: RouteReuseStrategyService,
    private downloadExcelPaddleQrModalService: DownloadExcelPaddleQrModalService,
    private modalService: MdbModalService
  ) { }

  ngOnInit(): void {
    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(() => {
      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

      this.ngAfterViewInit();
    });

    const styles = window['documentManager'].createElement('link');
    styles.href = 'paybee-spa/styles.css?v=398';
    styles.rel = 'stylesheet';
    window['$'](this.containerRef.nativeElement).append(styles);
  }

  ngAfterViewInit(): void {
    this.route.params.pipe(
      first(),
      takeUntil(this.takeUntilSubject)
    ).subscribe(params => {
      this.eventId = params.id;
      window['orgMain'].showRunEvent(this.eventId);
      if(window['orgMain'].sendInviteModalEventType){
        window['$']('#panelInPersonEventPageInviteTab').click();
      }
    });
  
  }

  ngOnDestroy(): void {
    window["$"]('#runEvent').empty()
    window["$"]('#runEvent').hide()

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.routeReuseStrategyService.status = false;
  }

  showRemindersPage() {
    const { scheduler, eventReportInvitationsModal, SchedulerTaskType, EventTypeInPerson, $ }: any = window;
    scheduler.reset();
    scheduler.data = eventReportInvitationsModal.event;
    scheduler.inPersonEventId = eventReportInvitationsModal.event.id;
    scheduler.eventPageId = eventReportInvitationsModal.event.eventPageId;

    scheduler.updateEventDateTime();

    const taskTypeList = [
        SchedulerTaskType.PendingCartReminder,
        SchedulerTaskType.InPersonEventReminder,
        SchedulerTaskType.InPersonAddGuestReminder,
        SchedulerTaskType.EventPageInviteReminder,
        SchedulerTaskType.InPersonSaveCardReminder
    ];

    let cancelledList = [];
    let scheduledList = [];
    let completedList = [];
    var sortRemindersByStatus = function(reminders) {
        for (let i = 0; i < reminders.length; i++) {
            if(reminders[i].status === 0) 
                scheduledList.push(reminders[i])
            if(reminders[i].status === 2 || reminders[i].status === 3)
                completedList.push(reminders[i])
            if(reminders[i].status === 4)
                cancelledList.push(reminders[i])
        }
    }

    return scheduler.getMultipleTaskListByEventId(scheduler.data.id, EventTypeInPerson, taskTypeList).then(() => {
      sortRemindersByStatus(scheduler.list);

        const recommendations = scheduler.getMultipleRecommendationList(taskTypeList);
        if(recommendations.length < 1) {
            $(`*[data-section="suggestedReminderCard"]`).hide();
        } else {
            $(`*[data-section="suggestedReminderCard"]`).show();
            const recommendationListHTML = scheduler.getRecommendationListHTML(recommendations, 'eventReport');
            $(`*[data-section="suggestedReminderListContainer"]`).html(recommendationListHTML);
        }

        if(scheduledList.length < 1) {
            $(`*[data-section="scheduledReminderCard"]`).hide();
        } else {
            $(`*[data-section="scheduledReminderCard"]`).show();
            const listHTML = scheduler.getScheduledTaskListHTML(scheduledList);
            $(`*[data-section="scheduledReminderListContainer"]`).html(listHTML);
            $('*[data-section="suggestedReminderCard"]').css('order', '1');
        }

        if(completedList.length < 1) {
            $(`*[data-section="completedReminderCard"]`).hide();
        } else {
            $(`*[data-section="completedReminderCard"]`).show();
            const listHTML = scheduler.getScheduledTaskListHTML(completedList);
            $(`*[data-section="completedReminderListContainer"]`).html(listHTML);
            $('*[data-section="suggestedReminderCard"]').css('order', '1');
        }

        if(cancelledList.length < 1) {
            $(`*[data-section="cancelledReminderCard"]`).hide();
        } else {
            $(`*[data-section="cancelledReminderCard"]`).show();
            const listHTML = scheduler.getScheduledTaskListHTML(cancelledList);
            $(`*[data-section="cancelledReminderListContainer"]`).html(listHTML);
            $('*[data-section="suggestedReminderCard"]').css('order', '1');
        }

        return null;
    }).then(() => {
        const { event } = eventReportInvitationsModal;

        const timestamp = event.inPersonEvent ?
            event.inPersonEvent.startDateTimeGmtUnix:
            event.startDateTimeGmtUnix;
        scheduler.timestamp[SchedulerTaskType.InPersonEventReminder] = timestamp;
        scheduler.timestamp[SchedulerTaskType.InPersonAddGuestReminder] = timestamp;
        scheduler.timestamp[SchedulerTaskType.InPersonSaveCardReminder] = timestamp;
        scheduler.timestamp[SchedulerTaskType.EventPageInviteReminder] = timestamp;
        scheduler.placeOfCall = 'eventReport';
        
        scheduler.updateReminders();
        const { ticketCampaignInfo: campaign } = window['orgMain'].selectedInPersonEvent;
        window['ticketingAndGuestsModal'].campaign = campaign;
        return scheduler.init(() => {
            this.showRemindersPage();

            if($("#scheduledReminderHeadingLink").hasClass("collapsed")) {
              $("#scheduledReminderHeadingLink").click();
          }
        });
    })
  }

  openSelectSizeModal() {
    const modalRef = this.downloadExcelPaddleQrModalService.open({eventId: this.eventId});
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.downloadExcelPaddleQrModalService.modalRef = null;
    })
  }

  openBulkCheckoutModal() {
    const modalRef = this.modalService.open(BulkCheckoutComponent, {
      data: {
        data: {
          placeOfCall: 'inPersonEvent'
        },
      },
      containerClass: 'mdb-modal-backdrop-paybee',
      modalClass: 'modal--paybee modal-lg',
      ignoreBackdropClick: true
    })

    modalRef.onClose.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((refreshAttendees: boolean) => {
      if (refreshAttendees) {
        window['$']("#refreshAttendees").click()
      }
    })
  }
}